(ns practitest.frontend.components2.issue-status
  (:require
    [clojure.string :as str]))

;; Some hardcoded issues statuses colors as in figma:
;;https://www.figma.com/file/0aTwitb3NTlNHmCpBFb3XA/Practitest-UX-Clients?type=design&node-id=2869-133792&mode=dev

(def statuses-map
  {"new"      {:label "new"
               :color "var(--pt-color-issue-new)"}
   "opened"   {:label "opened"
               :color "var(--pt-color-issue-opened)"}
   "assigned" {:label "assigned"
               :color "var(--pt-color-issue-assigned)"}
   "fixed"    {:label "fixed"
               :color "var(--pt-color-issue-fixed)"}
   "closed"   {:label "closed"
               :color "var(--pt-color-issue-closed)"}
   "rejected" {:label "rejected"
               :color "var(--pt-color-issue-rejected)"}})

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        ;; Use label itself here
        status)))

(defn get-status-color
  [status]
  (:color (get statuses-map status)))

(defn issue-status-component
  [status]
  [:<>
   (when (and status (not (str/blank? status)))
     (when-let [color (get-status-color (str/lower-case status))]
       [:span.status-indicator
        {:style {:color color}}]))
   (get-status-label status)])
